import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import client from "./client";
import API_ENDPOINTS from "../constants/api-endpoints";

type CB = { onSuccess?: (r: any) => void; onError?: (e: any) => void };

export const useAllPermissions = () =>
  useQuery({
    queryKey: ["permissions"],
    queryFn: () => client.get(API_ENDPOINTS.ROLES_PERMISSIONS).then((r) => r.data.data as any[]),
    refetchOnWindowFocus: false,
  });

export const useCreateRole = ({ onSuccess, onError }: CB = {}) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ companyId, data }: { companyId: number; data: any }) =>
      client.post(API_ENDPOINTS.ROLES_CREATE(companyId), data),
    onSuccess: (r) => { qc.invalidateQueries({ queryKey: ["roles"] }); onSuccess?.(r); },
    onError: (e) => onError?.(e),
  });
};

export const useUpdateRolePermissions = ({ onSuccess, onError }: CB = {}) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ roleId, permission_ids }: { roleId: number; permission_ids: number[] }) =>
      client.put(API_ENDPOINTS.ROLES_UPDATE_PERMS(roleId), { permission_ids, granted: true }),
    onSuccess: (r) => { qc.invalidateQueries({ queryKey: ["roles"] }); onSuccess?.(r); },
    onError: (e) => onError?.(e),
  });
};

export const useDeleteRole = ({ onSuccess, onError }: CB = {}) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (roleId: number) => client.delete(API_ENDPOINTS.ROLES_DELETE(roleId)),
    onSuccess: (r) => { qc.invalidateQueries({ queryKey: ["roles"] }); onSuccess?.(r); },
    onError: (e) => onError?.(e),
  });
};
